// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Ouroboros_TsBridge_Branding from "../Ouroboros.TsBridge.Branding/index.js";
import * as Simple_JSON from "../Simple.JSON/index.js";
import * as TsBridge_Monad from "../TsBridge.Monad/index.js";
var pure = /* #__PURE__ */ Control_Applicative.pure(TsBridge_Monad.applicativeTsBridgeM);
var OrganizationSignupSquareVerificationToken = function (x) {
    return x;
};
var OrganizationSignupSquareSourceId = function (x) {
    return x;
};
var OrganizationSignupSquareRegion = function (x) {
    return x;
};
var OrganizationSignupSquarePhone = function (x) {
    return x;
};
var OrganizationSignupSquareCountry = function (x) {
    return x;
};
var OrganizationSignupSquareCity = function (x) {
    return x;
};
var OrganizationSignupSquareAddressLine = function (x) {
    return x;
};
var writeOrganizationSignupSquareVerificationToken = Simple_JSON.writeForeignString;
var writeOrganizationSignupSquareSourceId = Simple_JSON.writeForeignString;
var writeOrganizationSignupSquareRegion = Simple_JSON.writeForeignString;
var writeOrganizationSignupSquarePhone = Simple_JSON.writeForeignString;
var writeOrganizationSignupSquareCountry = Simple_JSON.writeForeignString;
var writeOrganizationSignupSquareCity = Simple_JSON.writeForeignString;
var writeOrganizationSignupSquareAddressLine = Simple_JSON.writeForeignString;
var tsBridgeOrganizationSignupSquareVerificationToken = {
    tsBridge: function (v) {
        return pure(Ouroboros_TsBridge_Branding.brandedStringType("OrganizationSignupSquareVerificationToken")("__brandOrganizationSignupSquareVerificationToken"));
    }
};
var tsBridgeOrganizationSignupSquareSourceId = {
    tsBridge: function (v) {
        return pure(Ouroboros_TsBridge_Branding.brandedStringType("OrganizationSignupSquareSourceId")("__brandOrganizationSignupSquareSourceId"));
    }
};
var tsBridgeOrganizationSignupSquareRegion = {
    tsBridge: function (v) {
        return pure(Ouroboros_TsBridge_Branding.brandedStringType("OrganizationSignupSquareRegion")("__brandOrganizationSignupSquareRegion"));
    }
};
var tsBridgeOrganizationSignupSquarePhone = {
    tsBridge: function (v) {
        return pure(Ouroboros_TsBridge_Branding.brandedStringType("OrganizationSignupSquarePhone")("__brandOrganizationSignupSquarePhone"));
    }
};
var tsBridgeOrganizationSignupSquareCountry = {
    tsBridge: function (v) {
        return pure(Ouroboros_TsBridge_Branding.brandedStringType("OrganizationSignupSquareCountry")("__brandOrganizationSignupSquareCountry"));
    }
};
var tsBridgeOrganizationSignupSquareCity = {
    tsBridge: function (v) {
        return pure(Ouroboros_TsBridge_Branding.brandedStringType("OrganizationSignupSquareCity")("__brandOrganizationSignupSquareCity"));
    }
};
var tsBridgeOrganizationSignupSquareAddressLine = {
    tsBridge: function (v) {
        return pure(Ouroboros_TsBridge_Branding.brandedStringType("OrganizationSignupSquareAddressLine")("__brandOrganizationSignupSquareAddressLine"));
    }
};
var showOrganizationSignupSquareVerificationToken = Data_Show.showString;
var showOrganizationSignupSquareSourceId = Data_Show.showString;
var showOrganizationSignupSquareRegion = Data_Show.showString;
var showOrganizationSignupSquarePhone = Data_Show.showString;
var showOrganizationSignupSquareCountry = Data_Show.showString;
var showOrganizationSignupSquareCity = Data_Show.showString;
var showOrganizationSignupSquareAddressLine = Data_Show.showString;
var readOrganizationSignupSquareVerificationToken = Simple_JSON.readString;
var readOrganizationSignupSquareSourceId = Simple_JSON.readString;
var readOrganizationSignupSquareRegion = Simple_JSON.readString;
var readOrganizationSignupSquarePhone = Simple_JSON.readString;
var readOrganizationSignupSquareCountry = Simple_JSON.readString;
var readOrganizationSignupSquareCity = Simple_JSON.readString;
var readOrganizationSignupSquareAddressLine = Simple_JSON.readString;
var ordOrganizationSignupSquareVerificationToken = Data_Ord.ordString;
var ordOrganizationSignupSquareSourceId = Data_Ord.ordString;
var ordOrganizationSignupSquareRegion = Data_Ord.ordString;
var ordOrganizationSignupSquarePhone = Data_Ord.ordString;
var ordOrganizationSignupSquareCountry = Data_Ord.ordString;
var ordOrganizationSignupSquareCity = Data_Ord.ordString;
var ordOrganizationSignupSquareAddressLine = Data_Ord.ordString;
var newtypeOrganizationSignupSquareVerificationToken = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeOrganizationSignupSquareSourceId = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeOrganizationSignupSquareRegion = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeOrganizationSignupSquarePhone = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeOrganizationSignupSquareCountry = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeOrganizationSignupSquareCity = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeOrganizationSignupSquareAddressLine = {
    Coercible0: function () {
        return undefined;
    }
};
var eqOrganizationSignupSquareVerificationToken = Data_Eq.eqString;
var eqOrganizationSignupSquareSourceId = Data_Eq.eqString;
var eqOrganizationSignupSquareRegion = Data_Eq.eqString;
var eqOrganizationSignupSquarePhone = Data_Eq.eqString;
var eqOrganizationSignupSquareCountry = Data_Eq.eqString;
var eqOrganizationSignupSquareCity = Data_Eq.eqString;
var eqOrganizationSignupSquareAddressLine = Data_Eq.eqString;
export {
    OrganizationSignupSquareSourceId,
    OrganizationSignupSquareVerificationToken,
    OrganizationSignupSquarePhone,
    OrganizationSignupSquareAddressLine,
    OrganizationSignupSquareCity,
    OrganizationSignupSquareRegion,
    OrganizationSignupSquareCountry,
    newtypeOrganizationSignupSquareSourceId,
    eqOrganizationSignupSquareSourceId,
    ordOrganizationSignupSquareSourceId,
    showOrganizationSignupSquareSourceId,
    readOrganizationSignupSquareSourceId,
    writeOrganizationSignupSquareSourceId,
    tsBridgeOrganizationSignupSquareSourceId,
    newtypeOrganizationSignupSquareVerificationToken,
    eqOrganizationSignupSquareVerificationToken,
    ordOrganizationSignupSquareVerificationToken,
    showOrganizationSignupSquareVerificationToken,
    readOrganizationSignupSquareVerificationToken,
    writeOrganizationSignupSquareVerificationToken,
    tsBridgeOrganizationSignupSquareVerificationToken,
    newtypeOrganizationSignupSquarePhone,
    eqOrganizationSignupSquarePhone,
    ordOrganizationSignupSquarePhone,
    showOrganizationSignupSquarePhone,
    readOrganizationSignupSquarePhone,
    writeOrganizationSignupSquarePhone,
    tsBridgeOrganizationSignupSquarePhone,
    newtypeOrganizationSignupSquareAddressLine,
    eqOrganizationSignupSquareAddressLine,
    ordOrganizationSignupSquareAddressLine,
    showOrganizationSignupSquareAddressLine,
    readOrganizationSignupSquareAddressLine,
    writeOrganizationSignupSquareAddressLine,
    tsBridgeOrganizationSignupSquareAddressLine,
    newtypeOrganizationSignupSquareCity,
    eqOrganizationSignupSquareCity,
    ordOrganizationSignupSquareCity,
    showOrganizationSignupSquareCity,
    readOrganizationSignupSquareCity,
    writeOrganizationSignupSquareCity,
    tsBridgeOrganizationSignupSquareCity,
    newtypeOrganizationSignupSquareRegion,
    eqOrganizationSignupSquareRegion,
    ordOrganizationSignupSquareRegion,
    showOrganizationSignupSquareRegion,
    readOrganizationSignupSquareRegion,
    writeOrganizationSignupSquareRegion,
    tsBridgeOrganizationSignupSquareRegion,
    newtypeOrganizationSignupSquareCountry,
    eqOrganizationSignupSquareCountry,
    ordOrganizationSignupSquareCountry,
    showOrganizationSignupSquareCountry,
    readOrganizationSignupSquareCountry,
    writeOrganizationSignupSquareCountry,
    tsBridgeOrganizationSignupSquareCountry
};
//# sourceMappingURL=index.js.map
